export default {
  hint: "Conferma il pagamento con la tua banca per completare l'ordine.",
  cancel: 'Annulla pagamento',
};
